<template>
  <li>
    {{ option.nameKurz }}: {{ option.uvpBruttoAbweichung | currency }}
    <small class="d-flex align-items-center text-primary mb-2" v-b-modal="`modal-${componentId}-${option.id}`"
      ><fa-icon :icon="['fas', 'link']" class="mr-1"></fa-icon>Option verknüpfen ({{linkedOptions.length}})</small
    >
    <b-modal
      :id="`modal-${componentId}-${option.id}`"
      size="lg"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      v-on:ok="saveLinkedOptions()"
    >
      <template #modal-header>
        <div class="w-100 d-flex align-items-center justify-content-between">
          <h5 class="m-0">Optionen verknüpfen</h5>
        </div>
      </template>
      <template #modal-footer="{ ok }">
        <b-button variant="primary" v-on:click="ok()">
          OK
        </b-button>
      </template>

      <div v-for="(component, componentindex) in list" :key="componentindex">
        <div  v-if="(list.findIndex((el) => el.id == componentId )) < componentindex" class="mt-5">
          <!-- {{componentindex}} -->
          <h4>{{component.data.name}}</h4>
           <hr />

          <b-row align-h="between" v-for="(eachOption, optionIndex) in list[componentindex].data.optionen" :key="`option-${optionIndex}`" class="mb-1">
            <!-- {{component}} -->
            <b-col cols="10">
              <b-form-checkbox switch v-model="linkedOptions" :value="eachOption.id" @change="logLinkedOptions(eachOption.id)" :unchecked-value="null">
                {{ component.data.name }} {{ eachOption.name }}
              </b-form-checkbox>
            </b-col> 
            <b-col cols="2" class="text-right">
              <b-badge variant="success" class="text-center" v-if="linkedOptions.includes(eachOption.id) || checkIfIsSelectedInOtherComponent(list[componentindex].data.optionen )" >Sichtbar</b-badge>
              <b-badge variant="danger" class="text-center" v-else >Ausgeblendet</b-badge>
              <!-- linkedOptions.includes(eachOption.id) || -->
            </b-col>
          </b-row>
        </div>
      </div>
    </b-modal>
  </li>
</template>

<script>

export default {
  name: "NewDraggableOptionComponent",
  props: {
    option: Object,
    componentId: String,
    list: Array,
    componentData: Object,
    getLinkedOptions: Object
  },
  methods: {
    logLinkedOptions(id) {
      console.log(id)
      console.log('linked', this.linkedOptions)
    },
    saveLinkedOptions() {
      this.$emit("savedLinkedOptions", {
        componentId: this.componentId,
        originOption: this.option.id,
        linkedOptions: this.linkedOptions,
      })
    },
    allLinkedOptions(){
      let toReturn = [];
      this.list.forEach((item) => {   
        if(item?.linkedOptions && Object.entries(item?.linkedOptions).length > 0) {
          Object.entries(item?.linkedOptions).forEach(el=>{
            // console.log(el)
            toReturn = [...new Set([...toReturn ,...el[1]])]
          })
        }
        console.log(toReturn)
       })
       return toReturn
     },
    checkIfIsSelectedInOtherComponent(component){
    // wenn linkedOption für diese Component leer is und die Optionen in anderen Componenten gesetzt ist, dann soll diese Component auch nicht sichtbar sein.
      let isIn = true;
      // console.log(component)
      const allLinkedOptionsArray = this.allLinkedOptions()
      for (let i = 0; i < component.length; i++) {
        if(allLinkedOptionsArray.includes(component[i]?.id)){
          isIn = false
          break;   
        }
      }
      return isIn;
    },

  },
  computed: {
    availableOptions() {
      const result = [];

      this.list.forEach((item) => {
        item.data.optionen.forEach((option) => {
          if (this.componentId !== item.id) {
            result.push({
              id: option.id,
              optionName: option.name,
              componentName: item.data.name,
              checked: false,
            });
          }
        });
      });

      return result;
    },

  },
  data() {
    return {
      linkedOptions: [],
    }
  },
  mounted() {


    if (this.getLinkedOptions?.[this.option.id]) {

      this.linkedOptions = this.getLinkedOptions?.[this.option.id]
      // console.log(this.getLinkedOptions?.[this.option.id])
    } else {
      /* this.list.forEach((item) => {
        item.data.optionen.forEach((option) => {
          this.linkedOptions.push(option.id);
        });
      }); */
      this.linkedOptions = [];
    }
  }
}
</script>
